import { hrmUser, MfeUserNavData } from '@platform-services/hrm-mfe-global';

export async function getMfe() {
  const mfeEntry = await import('@/setup-mfe');
  return mfeEntry;
}

/** POPE's Defend SKU. hrm-mfe-global's `deriveEntitledProductKeys` matches Defend the same way. */
const DEFEND_SKU_NAME = 'DEFEND';

/**
 * The visibility keys this MFE grants. hrm-nav items gate on them, so they are a contract with
 * hrm-nav: rename one only alongside the nav entry that uses it. See docs/console-integration.md.
 */
export const DEFEND_NAV_KEYS = {
  /** Any page of this MFE. */
  admin: 'defend-admin',
  /** The onboarding wizard at /ecs-inbound/setup. */
  setup: 'defend-admin-setup',
} as const;

/**
 * The sidebar calls this for every MFE registered with `HasOnNavLoad`, whether or not the org has
 * Defend, and gives up after 10 seconds, so it must answer fast and never throw. An org without the
 * SKU gets no keys, and the Defend items stay hidden.
 */
export function onNavLoad() {
  const skus = hrmUser.userDetails?.targetOrganization.entitlementSkuNames ?? [];
  const entitled = skus.includes(DEFEND_SKU_NAME);

  return new MfeUserNavData({
    visibilityKeys: entitled ? [DEFEND_NAV_KEYS.admin, DEFEND_NAV_KEYS.setup] : [],
    replacementNavItems: [],
  });
}
